import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "../util/redux/typed-reducers";
import { ReduxDispatch } from "./reducers";

/**
 * Action factory + actions
 */
const actionFactory = actionCreatorFactory("HypoMobiili/Snackbar");
const showSnackbarAction = actionFactory<string>("SHOW_SNACKBAR");
export const hideSnackbarAction = actionFactory("HIDE_SNACKBAR");

export function showSnackbar(text: string) {
    return async (dispatch: ReduxDispatch) => {
        // First hide any snackbar that exists
        await dispatch(hideSnackbarAction());

        // Then show the snackbar
        await dispatch(showSnackbarAction(text));
    };
}

/**
 * The internal state of this reducer
 */
export class SnackbarState {
    show: boolean;
    text: string;
}

/**
 * The reducer.
 *
 * The module exports this as default
 */

const intialCommonState: SnackbarState = {
    show: false,
    text: "",
};

export const SnackbarReducer = reducerWithInitialState(intialCommonState)
    .case(showSnackbarAction, (state, action) => {
        return {
            ...state,
            show: true,
            text: action.payload,
        };
    })
    .case(hideSnackbarAction, (state, action) => {
        return {
            ...state,
            show: false,
            text: "",
        };
    });

export default SnackbarReducer;

/**
 * Selectors
 */



// WEBPACK FOOTER //
// ./src/ducks/snackbar.ts